import styles from '~/styles/atoms/line/line.module.scss'
import { addClass } from '~/common/utils/html'

interface Props {
  noMargin?: boolean
}

const Line = ({noMargin = false}: Props) => {
  return (
    <hr className={styles.line + addClass(noMargin ? styles.no : styles.margin)}/>
  )
}

export default Line